import styled from "styled-components";
import breakpoints from "Helpers/BreakpointHelper";
import media from "styled-media-query";
import { SIDEMENU, MAINMENU } from "Framework/consts/menuTypes";
import { PrimaryButton } from "BaseComponents/Button";
export const ButtonWrapper = styled.div`
  padding: 29px 16px;
  width: auto;
  background-color: ${({ theme }) => theme.colors.lightgrey};
  ${PrimaryButton} {
    margin: 0;
  }
`;
export const MenuItemWrapper = styled("a").attrs(
  ({ IsActive, justifyContent }) => ({
    fontWeight: IsActive ? "bold" : "",
    justifyContent: justifyContent ? justifyContent : "space-between",
  })
)`
  width: 100%;
  flex-grow: 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: ${({ justifyContent }) => justifyContent};
  min-height: 43px;
  transition: 0.2s ease;
  border-top: ${({ borderTop, theme }) =>
    borderTop ? "1px solid rgb(195 195 195)" : ""};

  &:hover,
  &:hover + ${MenuButtonWrapper} {
    transition: 0.2s ease;
    background-color: ${({ theme, Depth }) =>
      Depth > 1 ? theme.colors.bg1 : ""};
  }

  & {
    ${({ MenuType, Depth }) =>
      MenuType == SIDEMENU && {
        paddingLeft: 10 + Depth * 10 + "px",
      }}
  }
  & {
    ${({ MenuType, Depth, bgColor, IsExpanded, theme }) =>
      MenuType == MAINMENU && {
        padding: Depth == 1 ? "10px 0" : "7px 0",
        backgroundColor:
          Depth > 2 ? theme.colors.white : bgColor ? bgColor : "",
        minHeight: "60px",
      }}
  }
`;

export const MenuItemText = styled.span.attrs(() => ({
  tabIndex: 0,
}))`
  & {
    color: ${({ Depth }) => (Depth == 1 ? "white" : "")};
    font-weight: ${({ IsExpanded }) => (IsExpanded ? "bold" : "")};
    font-size: 16px;
    display: flex;
    align-items: center;
  }
  & {
    ${({ Color, Depth, MenuType, theme }) =>
      MenuType == MAINMENU
        ? {
            color: Color ? Color : theme.colors.primary,
            paddingLeft: "1rem",
            paddingRight: "1rem",
            fontSize: 22 - Depth + "px",
          }
        : {
            fontSize: 18 - Depth + "px",
          }}
  }
`;

export const MenuItemTextParent = styled(MenuItemText).attrs(
  ({ IsExpanded, lang }) => ({
    "aria-expanded": IsExpanded ? "true" : !IsExpanded ? "false" : null,
  })
)``;

export const MenuButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 56px;
  transition: 0.2s ease;
  &:hover {
    background-color: transparent;
  }
  i::before {
    font-size: ${({ IconSize }) => IconSize};
  }
`;

export const MainMenuWrapper = styled.div`
  width: 100%;
  z-index: 100;
  overflow: auto;
  transition: all 0.5s ease;
  position: sticky;
  top: 70px;
  width: 100%;
  z-index: 100;
  overflow: scroll;
  height: ${({ open }) => (open ? "calc(100vh - 70px)" : "0")}; 
  background-color: ${({ theme }) => theme.colors.bg2};
  transition: all 0.5s ease;
  padding-bottom: ${({ open }) => (open ? "120px" : "0")};

  ${media.greaterThan(breakpoints.ipadPlus)`
			display: none;
		`};
`;

const hideStyles = `
	opacity: 0;
	z-index: 0;
	// height: 0;
`;

export const CollapsableMenuItem = styled.div.attrs(({ IsExpanded }) => ({}))`
  .fade-enter {
    max-height: 0;
    opacity: 0;
  }

  .fade-enter-active {
    max-height: ${({ MenuType }) => (MenuType == MAINMENU ? "65px" : "43px")};
    opacity: 1;
    transition: all 300ms ease;
  }

  .fade-exit {
    max-height: ${({ MenuType }) => (MenuType == MAINMENU ? "30px" : "20px")};
    opacity: 1;
    opacity: 0;
    transition: max-height 300ms ease;
  }

  .fade-exit-active {
    max-height: 0;
    opacity: 0;
    transition: max-height 300ms ease;
  }
  & {
    width: 100%;
    float: right;
  }
  & {
    ${({ Depth, IsExpanded, HasChildren, MenuType, Display, theme }) =>
      MenuType == MAINMENU && {
        backgroundColor:
          Depth > 1 && IsExpanded && HasChildren
            ? theme.colors.bg2
            : Depth > 2
            ? theme.colors.bg2
            : "",
      }}
  }
  & {
  }
`;


export const ItemsScrollWraper = styled.div.attrs(({ IsExpanded }) => ({}))`
    max-height: 100vh;
    overflow-y: scroll;
`;